export const navigation = {
    preventSwipeBack: () => {},
};
